import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.projects.root,
    element: loadable(() => import('./pages/ProjectsPage')),
    children: [
      {
        path: paths.projects.children.details,
        element: loadable(() => import('./pages/ProjectDetails')),
        children: [
          {
            path: paths.projects.details.tab,
            element: <Outlet />,
          },
        ],
      },
    ],
  },
];
